/* eslint-disable react-hooks/exhaustive-deps */
import JoditEditor from "jodit-react";
import { memo, useEffect, useMemo, useRef, useState } from "react";

//This defaultButtonsList is an optional alternative to the button arrangement.
const defaultButtonsList = [
    "source",
    "|",
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    "ul",
    "ol",
    "|",
    "outdent",
    "indent",
    "|",
    "font",
    "fontsize",
    "brush",
    "paragraph",
    "|",
    "image",
    "table",
    "link",
    "|",
    "align",
    "undo",
    "redo",
    "|",
    "hr",
    "eraser",
    "copyformat",
    "|",
    "fullsize",
  ];

const JoditField = ({ elementName, startingValue, setResourceState }) => {

    const editor = useRef(null);

    const config = useMemo(
        () => ({
            readonly: false, // all options from https://xdsoft.net/jodit/docs/,
            toolbar: true,
            spellcheck: true,
            language: "en",
            toolbarButtonSize: "medium",
            toolbarAdaptive: false,
            showCharsCounter: true,
            showWordsCounter: true,
            showXPathInStatusbar: false,
            askBeforePasteHTML: true,
            askBeforePasteFromWord: true,
            defaultActionOnPaste: "insert_clear_html",
            uploader: {
                insertImageAsBase64URI: true,
              },
            beautifyHTML: true,
            useSearch: true,
            disablePlugins: "video,file,print",
            //placeholder: '' //elementName ||
        }), []
    );

    const [contentState, setContentState] = useState(startingValue);

    useEffect(() => {
        setContentState(startingValue)
    }, [startingValue])
/*
    const onBlurEditor = (newValue, event) => {
        if (startingValue !== newValue || newValue !== "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>") {
            if (event.preventDefault) {
                event.preventDefault();
                event.stopPropagation();
            }
            newValue = newValue.replaceAll(" < ", " &lt; ").replaceAll(" > ", " &gt; ").replaceAll(" & ", " &amp; ");
            editor.current.value = newValue;
            setResourceState(prevState => { return { ...prevState, [elementName]: newValue } });
        }
    };
*/
    useEffect(() => {
        if (startingValue !== contentState || 
            (!startingValue && !contentState)) {
            let newValue = contentState.replaceAll(" < ", " &lt; ").replaceAll(" > ", " &gt; ").replaceAll(" & ", " &amp; ");
            editor.current.value = newValue;
            setResourceState(prevState => { return { ...prevState, [elementName]: newValue } });
        }
    }, [contentState]);
    
    return <JoditEditor
        ref={editor}
        value={contentState}
        config={config}
        tabIndex={1} // tabIndex of textarea
        //onBlur={onBlurEditor}
        onChange={(newContent) => setContentState(newContent)}
    />;
};
//XhtmlEntry startingValue is expecting a Narrative datatype div element value without the divWrapper
const XhtmlEntry = memo(({ elementName, startingValue, setResourceState }) => {

    return <div>
      <JoditField
        elementName={elementName}
        startingValue={startingValue} setResourceState={setResourceState} />
      <br />
    </div>
  });

export default XhtmlEntry;